webpackJsonp([96704960819578],{

/***/ 557:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"frontmatter":{"date":"2019-08-15","path":"/projects/agi-suretrack-pro","summary":"single-page marketing website","tags":["web","fedev","es6","styledcomponents","react","jsx","gatsby","static","aws","applydigital"],"taskSummary":"all development","title":"AGI Suretrack Pro","url":null,"writeupDate":"2019-09-19"},"html":"<p>This is a sister site of <a href=\"/projects/agi-suretrack-farm\">AGI Suretrack Farm</a>,\nmarketing an expanded version of the product.</p>\n<p>The very similar design meant a lot of code from the earlier site could be used\nas a base, and so development was very fast.\nThis also meant I could clear up some of the pieces which were previously\nrushed.\nAs a result, this site is considerably nicer to view on mobile.</p>\n<p>Like AGI Suretrack Farm, this is a static build, generated by Gatsby, with\nStyled Components.</p>"}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---projects-agi-suretrack-pro-c8ba4871481a28d0b783.js